export default {
  labels: {
    signed_by: 'Assinado por {{name}} em {{date}}',
    signed_by_no_date: 'Assinado por {{name}}',
  },
  buttons: {
    retry: 'Tentar novamente',
  },
  errors: {
    load_failed: 'Não foi possível carregar o contrato. Verifique a sua ligação e tente novamente.',
  },
};
